export namespace ISignInMagicLinkXP {
  export enum Bucket {
    BUCKET_UNKNOWN = 'BUCKET_UNKNOWN',
    CONTROL = 'CONTROL',
    /**
     * For New ML Experience, ML Prominence + Forgot Password
     */
    VARIANT_A = 'VARIANT_A',
    /**
     * For New ML Experience Consistent Copy Change, ML Prominence + No Forgot Password
     */
    VARIANT_B = 'VARIANT_B',
  }

  /**
   * Return an instance of ISignInMagicLinkXP with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<ISignInMagicLinkXP>
  ): ISignInMagicLinkXP =>
    ({
      ...(partial ?? {}),
    }) as ISignInMagicLinkXP;
}

/**
 * PRD: https://www.notion.so/faire/Sign-in-flow-b9efea9e78224d9f8c42dccbdb2c95d7
 */
export interface ISignInMagicLinkXP {}
